import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  Alert,
  Button,
  Box,
  Typography,
} from '@mui/material';
import SuccessGIF from '../../../landingPage/images/Success animation.gif';

const StyledContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const StyledButton = styled(Button)`
  margin: 16px auto;
  display: block;
  font-weight: bold;
  text-transform: none;
`;

const SuccessPage = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const paymentSuccessful = true;

    if (paymentSuccessful) {
      setOpenDialog(true);
      const timeoutId = setTimeout(() => {
        handleDialogClose();
      }, 3500);
      return () => clearTimeout(timeoutId);
    }
    return () => { };
    // eslint-disable-next-line
  }, []);

  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate('/dashboard/wallet');
  };

  return (
    <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="xs" fullWidth>
      <Typography variant='h5' mt={4} textAlign='center'>🎉 Congratulations!</Typography>
      <StyledContent>
        <Alert
          severity="success"
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          Your wallet balance has been updated.
        </Alert>
        <Box mt={2}>
          <img
            src={SuccessGIF}
            alt="Success"
            style={{ width: 80, height: 80, objectFit: 'contain' }}
          />
        </Box>
      </StyledContent>
      <StyledButton variant="contained" color="primary" size='small' onClick={handleDialogClose}>
        OK
      </StyledButton>
    </Dialog>
  );
};

export default SuccessPage;
